import { number } from '../../../Common/Util/number';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const Indicators = () => {
    const { chartData } = useVaccinationChartsDataContext();

    return (
        <div className="info-container-dashboards-green">
            <div className="info-box-dashboards-green">
                <span className="info-value-green-dashboards">
                    {number.formatToBRNumber(
                        chartData?.indicators?.totalVaccination || 0
                    )}
                </span>
                <span className="info-label">Total de Vacinação</span>
            </div>
        </div>
    );
};
